import React from "react";
import { Route, Router, Switch } from "react-router-dom";
import "fontsource-roboto";
import { Provider } from 'react-redux'

import Login from "./components/core/auth/Login";
import NotFoundComponent from "./components/shared/not-found/NotFoundComponent";
import history from "./history";
import DashboardLayout from "./layouts/dashboardLayout";
import store from "./redux/store/store";
import Configuration from "./components/core/config/Configuration";

export default function App() {
  return (
    <Provider store={store}>
      <Router history={history}>
        <Configuration>
          <Switch>
            <Route exact={true} path="/" component={Login} />
            <Route path="/login" component={Login} />
            <Route path="/dashboard" component={DashboardLayout} />
            <Route path="*" component={NotFoundComponent} />
          </Switch>
        </Configuration>
      </Router>
    </Provider>
  );
}
